/**
 * @generated SignedSource<<154a96117a1726d4dd07dd457c0cc15e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HubspotLegacyDisconnectInput = {
  clientMutationId?: string | null;
};
export type HubspotIntegrationLegacyDisconnectMutation$variables = {
  input: HubspotLegacyDisconnectInput;
};
export type HubspotIntegrationLegacyDisconnectMutation$data = {
  readonly disconnectLegacyHubspot: {
    readonly ok: boolean;
  } | null;
};
export type HubspotIntegrationLegacyDisconnectMutation = {
  response: HubspotIntegrationLegacyDisconnectMutation$data;
  variables: HubspotIntegrationLegacyDisconnectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HubspotLegacyDisconnectPayload",
    "kind": "LinkedField",
    "name": "disconnectLegacyHubspot",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotIntegrationLegacyDisconnectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubspotIntegrationLegacyDisconnectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "642a79377dc39b8aa431c3185d4a918f",
    "id": null,
    "metadata": {},
    "name": "HubspotIntegrationLegacyDisconnectMutation",
    "operationKind": "mutation",
    "text": "mutation HubspotIntegrationLegacyDisconnectMutation(\n  $input: HubspotLegacyDisconnectInput!\n) {\n  disconnectLegacyHubspot(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8a0faacb0dafcea309c9633f25a2e0a";

export default node;
